// src/components/SimpleComponents/SimpleSlider.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Slider } from 'antd';
import SimpleFormItem from './SimpleFormItem';
import useFormElement from 'hooks/useFormElement';
import { useSimpleFormContext } from './SimpleFormProvider';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SimpleSlider = ({
  name,
  subdocumentField,
  label,
  min = 0,
  max = 100,
  step = 1,
  marks,
  disabled,
  onChange,
  ...props
}) => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const { locked, disabledFields } = useSimpleFormContext() || {};

  // ---------------------------------------------------------------------------
  // 2. HOOKS & REFS
  // ---------------------------------------------------------------------------
  const elementProps = useFormElement(name, subdocumentField);
  const { fullFieldName, flattenFieldName } = elementProps;

  // ---------------------------------------------------------------------------
  // 3. LOCAL VARIABLES I
  // ---------------------------------------------------------------------------
  const isDisabled = disabled || locked || disabledFields?.includes(flattenFieldName);

  // ---------------------------------------------------------------------------
  // 4. UI
  // ---------------------------------------------------------------------------
  return (
    <SimpleFormItem
      name={fullFieldName}
      label={label}
      elementProps={elementProps}
      {...props}
    >
      <Slider
        min={min}
        max={max}
        step={step}
        marks={marks}
        disabled={isDisabled}
        onChange={onChange}
      />
    </SimpleFormItem>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleSlider;
